 const pageIndex = {
    INFO_PAGE: 0,
    CONTENT_PAGE: 1
}

const templateType = {
    TYPE1: 1,
    TYPE2: 2,
    TYPE3: 3,
    TYPE4: 4,
    TYPE5: 5,
}

const showLayout = {
    PRIVILEGE_NAME:1,
    PRIVILEGE_DESC: 2,
    PRIVILEGE_REMARK: 3,
    PRIVILEGE_TERM: 4,
    PRIVILEGE_BG: 5,
    PRIVILEGE_LOGO: 6
}

const expireType = {
    EXPIRE_DATE: 1,
    REDEEM_DATE: 2,
}

const statusAction = {
    ACTIVE: 1,
    INACTVE: 2
}

const booleanData = {
    TRUE: 1,
    FALSE: 0
}


export {pageIndex,templateType,showLayout,expireType,statusAction,booleanData}

